// Active Colors
const ACTIVE_DOT_COLOUR = '#1F77B4';
const ACTIVE_BAR_COLOUR = '#CF8C37';

// Common color combinations
export const BENCHMARK_COLOUR_COMBOS = {
  ACTIVE_GAUGE: {
    foreground: ACTIVE_BAR_COLOUR,
    dot: ACTIVE_DOT_COLOUR,
    scoreBox: ACTIVE_DOT_COLOUR,
  },
  ACTIVE_DRIVERS: {
    progressBar: ACTIVE_BAR_COLOUR,
    dot: ACTIVE_DOT_COLOUR,
    scoreBox: ACTIVE_DOT_COLOUR,
  },
};
